<div class="file-list-element flex flex-start-center">
  @if (!converting) {
    @if (file && blobUrl) {
      <a
        [attr.title]="file.name"
        (click)="openFile($event)"
        class="file-name download"
        color="primary"
        data-test-id="file-upload-element-fileName"
        mat-button
        type="button"
      >
        {{ file.name }}
      </a>
    }
    <button
      [disableRipple]="true"
      (click)="emitFileRemoval()"
      class="color-on-hover remove-file-btn"
      color="warn"
      data-test-id="file-upload-element-removeFileBtn"
      mat-icon-button
    >
      <mat-icon class="no-transition" svgIcon="close_tiny"></mat-icon>
    </button>
  }
</div>
